import { constraints, datatypes, inputTypes } from "data/globalData";

export const fabricTableColumns = {
	fabric_quality: {
		name: "Fabric Quality",
		key: "fabric_quality",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	description: {
		name: "Description",
		key: "description",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	consumption: {
		name: "Consumption",
		key: "consumption",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	price: {
		name: "Price",
		key: "price",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	value: {
		name: "Value",
		key: "value",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	supplier: {
		name: "Supplier",
		key: "supplier",
		input_type: inputTypes.SELECT.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
};

export const dummyFabricTableData = [
	{
		id: 1,
		fabric_quality: "100% COTTON POPLIN",
		description: "BODY FABRIC",
		consumption: 2.2,
		price: 155.0,
		value: 341,
		supplier: "Benkatesh",
	},
	{
		id: 2,
		fabric_quality: "100% cotton  VOILE 92X80",
		description: "LINING",
		consumption: 1.53,
		price: 92.0,
		value: 140.76,
		supplier: "Drishya",
	},
];
export const defaultFabricTotalRow = {
	id: "TOTAL",
	fabric_quality: "TOTAL",
	category: " Fabric",
	price: 0,
	value: 0,
};

export const checkForFabricTotalColumn = (row) => {
	if (row.id === "TOTAL" || row?.[fabricTableColumns.fabric_quality.key] === "TOTAL") return true;
	return false;
};
export const calculateTotalRow = (allRows) => {
	let price = 0;
	let value = 0;
	allRows?.forEach((row) => {
		if (!isNaN(row?.[fabricTableColumns.price.key])) price += +row?.[fabricTableColumns.price.key];
		if (!isNaN(row?.[fabricTableColumns.value.key])) value += +row?.[fabricTableColumns.value.key];
	});
	return { ...defaultFabricTotalRow, [fabricTableColumns.price.key]: price, [fabricTableColumns.value.key]: value };
};
